import React from 'react'
import styles from './styles.css'
import ReactMarkdown from 'react-markdown'
import { Image } from '@deal/components'
import { Section as SectionProps } from '../schema'

interface Video {
  url: string
  type: string
}

const Section: React.SFC<SectionProps> = ({ header, subHeader, body, expertTip, image }) => {
  const videos: Video[] = []
  const bodyWithoutVideos = body.replace(/\!\[.*]\(\/\/(.*)(\.(\w*)\))/gi, (_, p1, __, p3) => {
    videos.push({ url: `http://${p1}.${p3}`, type: `video/${p3}` })
    return ''
  })

  return (
    <div className={styles.section}>
      {subHeader && <div className={styles.subHeader}>{subHeader}</div>}
      {header && <div className={styles.header}>{header}</div>}
      {image && (
        <div className={styles.imageContainer}>
          <Image
            className={styles.image}
            src={image.imageUrl}
            imgixParams={{ fit: 'fill' }}
            lazyLoad={true}
            htmlAttributes={{
              alt: `${header} Itinerary Header`
            }}
          />
        </div>
      )}
      <div className={styles.body}>
        <ReactMarkdown source={bodyWithoutVideos} />
        {videos.map(({ url, type }) => (
          <video width="600" controls>
            <source src={url} type={type} />
          </video>
        ))}
      </div>
      {expertTip && (
        <div className={styles.tipBox}>
          <div className={styles.tip}>
            <div className={styles.tipBody}>
              <span className={styles.mobTitle}>👌 Expert tip: </span>
              {expertTip}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Section
